import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-action',
  templateUrl: './card-action.component.html',
  styleUrls: ['./card-action.component.sass']
})
export class CardActionComponent implements OnInit {
  @Input() bullet = '';
  @Input() title = '';
  @Input() text = '';
  @Input() icon = '';
  @Input() buttonText = '';
  @Input() buttonLink = '';
  @Input() status = '';

  constructor() { }

  ngOnInit() {
  }

  isOk() {
    return (this.status || '').indexOf('VALIDATED') > -1;
  }

  isPending() {
    return (this.status || '').indexOf('PENDING') > -1;
  }

  isActive() {
    return this.status === 'active';
  }

  isInactive() {
    return !this.status || (this.status || '').indexOf('TODO') > -1;
  }

  getButtonText() {
    if (this.isOk()) {
      return 'shared.status.VALIDATED';
    }

    if (this.isPending()) {
      return 'shared.status.PENDING';
    }

    return this.buttonText;
  }
}
